module.exports = __webpack_public_path__ + "img/submitted.37e3d7b0.svg";